import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

export default function (app) {
  app.use(VCalendar, {});
}
